import {
  getCSRFTokenValue,
} from "./js/helper";

jQuery(function ($) {
  console.log("gender-and-inclusion ready!");

  $(".gi-pie--hover").on("mouseenter", function () {
    $(".gi-pie--hover").css("opacity", "0.2");
    $(this).css("opacity", "1");

    const index = $(this).data("index");
    $('.gi-pie--slice').css("opacity", "0.25");
    $('.gi-pie--slice_' + index).css("opacity", "1");
  });

  $(".gi-pie--hover").on("mouseleave", function () {
    $(".gi-pie--hover").css("opacity", "1");
    $('.gi-pie--slice').css("opacity", "1");
  });

  $(".gi-pie--cat-hover").on("mouseenter", function () {
    $(".gi-pie--cat-hover").css("opacity", "0.2");
    $(this).css("opacity", "1");
  });

  $(".gi-pie--cat-hover").on("mouseleave", function () {
    $(".gi-pie--cat-hover").css("opacity", "1");
  });

  // Debugging code for dot position
  const debugElement = $(".gi-pie--debug_toggle");

  let clickCount = 0;
  let clickTimer = null;

  debugElement.on("click", () => {
    clickCount++;

    if (clickTimer) clearTimeout(clickTimer);

    if (clickCount === 10) {
      enableDebugging();
      clickCount = 0; // Reset count
      return;
    }

    // Reset click count after 500ms
    clickTimer = setTimeout(() => {
      clickCount = 0;
    }, 1000);
  });

  function enableDebugging() {
    console.log("Debug enabled");

    const pieSVG = $("#gi-pie--svg");
    pieSVG.find("circle").attr("fill", "red");

    const container = document.querySelector(".gi-pie--dot__container");

    // $('.dot-position').show();

    $(".gi-pie--dot").each(function () {
      const dot = this;

      dot.addEventListener("mousedown", (event) => {
        event.preventDefault();

        const containerRect = container.getBoundingClientRect();
        const onMouseMove = (e) => {
          // Calculate new position as percentages
          let left =
            ((e.clientX - containerRect.left) / containerRect.width) * 100;
          let top =
            ((e.clientY - containerRect.top) / containerRect.height) * 100;

          // Constrain the values to 0% - 100%
          left = Math.max(0, Math.min(100, left)).toFixed(2);
          top = Math.max(0, Math.min(100, top)).toFixed(2);

          // left = left.toFixed(2);
          // top = left.toFixed(2);

          // $(".dot-position").text(`Top: ${top}, Left: ${left}`);

          // Apply new positions
          dot.style.left = `${left}%`;
          dot.style.top = `${top}%`;
        };

        // Attach move and up listeners to the document
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener(
          "mouseup",
          () => {
            document.removeEventListener("mousemove", onMouseMove);
          },
          { once: true }
        );
      });
    });

    $(".gi-pie--dot").on("click", function (e) {
      e.preventDefault();
    });

    $('.gi-pie--debug').show();
  }

  async function getDotsPosition() {
    let positions = [];

    // NOTE: Scan for all dots and get their position
    $(".gi-pie--dot").each(function (idx) {
      const dot = $(this);
      const id = dot.attr("id");

      // Only get the position if it has inline styles
      if (this.style.top !== '' && this.style.left !== '') {
        positions.push({ id, top: this.style.top, left: this.style.left });
      }
    });

    // console.log('positions', positions);

    const json = JSON.stringify(positions);

    const pid = $('#gi-pie-id').data('id');

    const data = {
      pid,
      json
    }

    // console.log('data', data);

    $('.gi-pie--debug_message').css('color', 'black');
    $('.gi-pie--debug_message').text('Saving dots positions...');

    const csrfToken = await getCSRFTokenValue();

    $.ajax({
      url: "/api/genderinclusion/dots",
      method: "POST",
      data: JSON.stringify(data),
      dataType: "json",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
      },
      success: function (response) {
        // console.log('response', response);

        $('.gi-pie--debug_message').css('color', 'green');
        $('.gi-pie--debug_message').text('Dots positions saved successfully!');
      },
      error: function (xhr, status, error) {
        console.log('xhr', xhr);
        console.log('xhr.responseText', xhr.responseText);
        console.log('status', status);
        console.log('error', error);

        const errorMsg = JSON.parse(xhr.responseText);

        $('.gi-pie--debug_message').css('color', 'red');
        $('.gi-pie--debug_message').text(errorMsg.message);
      },
    });
  }

  $('#save-positions').on('click', function(){
    getDotsPosition();
  });

  const dotsPositionJson = $('#gi-pie-id').data('json');

  if (Array.isArray(dotsPositionJson)) {
    dotsPositionJson.map(dot => {
      const dotElement = $(`#${dot.id}`);
      dotElement.css('top', `${dot.top}`);
      dotElement.css('left', `${dot.left}`);
    });
  }

  $('.gi-pie--dot').show();

  // setTimeout(() => {
  //   console.clear();
  //   enableDebugging();
  //   console.log('dotsPositionJson', dotsPositionJson);
  // }, 1000);
});
